var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvayaOnecloudTopLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "35px",
    viewBox: "0 0 120 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 16") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing-Page-\\u2013-Desktop",
    transform: "translate(-222.000000, -61.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(222.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "104.519658 0 92.4137931 24.8275862 97.2948398 24.8275862 99.0580982 21.0591839 110.113511 21.0591839 108.786625 17.7768995 100.59626 17.7768995 106.203935 5.65754372 115.118953 24.8275862 120 24.8275862 107.89611 0",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "12.1078391 0 0 24.8275862 4.88302123 24.8275862 6.64825414 21.0591839 17.6977434 21.0591839 16.3748059 17.7768995 8.1864157 17.7768995 13.7940907 5.65754372 22.7071347 24.8275862 27.5862069 24.8275862 15.4842914 0",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "57.623106 0 45.5172414 24.8275862 50.3982881 24.8275862 52.1615465 21.0591839 63.2169593 21.0591839 61.8900728 17.7768995 53.699708 17.7768995 59.3093576 5.65754372 68.2243761 24.8275862 73.1034483 24.8275862 60.9995582 0",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    points: "46.1559884 0 37.2403918 19.5336429 28.3188698 0 23.4482759 0 35.547732 24.8275862 35.7491921 24.8275862 38.7236911 24.8275862 38.9310765 24.8275862 51.0344828 0",
    fill: "#DA291C"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    points: "91.6798527 0 82.3942671 20.0938244 73.8433131 0 68.9655172 0 79.9751173 25.0703882 75.1763141 34.4827586 79.8447795 34.4827586 96.5517241 0",
    fill: "#DA291C"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvayaOnecloudTopLogo);
export default __webpack_public_path__ + "static/media/avaya-onecloud-top-logo.80fb65ba81a13464302d32eab5ea05ae.svg";
export { ForwardRef as ReactComponent };